// How a by-instance trend names its points, in the viewer's own timezone:
// the short date, plus the time of day whenever another instance shares that
// date - a survey can send more than once on the same day, and then the date
// alone names every one of them the same.
export const getCompactInstanceLabels = (
  scheduledDatetimes: string[],
  locale: string
): string[] => {
  const instants = scheduledDatetimes.map(
    (scheduledDatetime) => new Date(scheduledDatetime)
  );
  const dates = instants.map((instant) =>
    instant.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  );
  const countByDate = dates.reduce<Record<string, number>>((acc, date) => {
    acc[date] = (acc[date] ?? 0) + 1;
    return acc;
  }, {});

  return dates.map((date, index) =>
    countByDate[date] > 1
      ? `${date} ${instants[index].toLocaleTimeString(locale, {
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        })}`
      : date
  );
};
